export default "__VITE_ASSET__gqjnouS4__"